export default class LogApi {

    constructor(api) {
        this.api = api;
    }

    progressSyncIssues(filters, callback, error) {
        const params = new URLSearchParams();
        if (filters?.companyId) {
            params.append("companyId", filters.companyId);
        }
        if (filters?.searchTerm) {
            params.append("searchTerm", filters.searchTerm);
        }
        if (filters?.limit) {
            params.append("limit", filters.limit);
        }

        this.api.getRaw((axios) => {
            axios.get(`log/progress-sync-issues?${params.toString()}`).then((response) => {
                callback(response.data);
            }).catch((err) => {
                if (error) error(err);
                console.error(err);
            });
        });
    }
}
